import moment from 'moment';
import { TYPES_VIEW } from '../../constans/types-view';

import {
    SWITCH_TYPE,
    SWITCH_FILIAL,
    SWITCH_SPECIALITY,
    SWITCH_DATE,
    SWITCH_DOCTOR,
    INIT_ATTR_PARAMS,
    SWITCH_INIT
} from './actions';

const initialState = {
    showFilter: 1,
    typeView: {
        label: 'По месяцам',
        value: 'month'
    },
    speciality: null,
    filial: null,
    doctor: null,
    date: moment()
};

window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...initialState };

export default function reduser(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SWITCH_TYPE: {
            if (payload.value === 2) {
                const date = moment();
                window.vpriemScheduleParams = {
                    ...window.vpriemScheduleParams,
                    ...state,
                    typeView:
                    payload,
                    date
                };
                return { ...state, typeView: payload, date };
            }
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...state, typeView: payload };
            return { ...state, typeView: payload };
        }
        case SWITCH_FILIAL:
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...state, filial: payload };
            return { ...state, filial: payload };
        case SWITCH_SPECIALITY:
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...state, speciality: payload };
            return { ...state, speciality: payload };
        case SWITCH_DATE:
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...state, date: payload };
            return { ...state, date: payload };
        case SWITCH_DOCTOR:
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...state, doctor: payload };
            return { ...state, doctor: payload };
        case SWITCH_INIT:
            window.vpriemScheduleParams = { ...window.vpriemScheduleParams, ...initialState };
            return { ...window.vpriemScheduleParams, ...state, ...initialState };
        case INIT_ATTR_PARAMS:
            window.vpriemScheduleParams = {
                ...window.vpriemScheduleParams,
                ...state,
                typeView: payload.typeView !== null ? TYPES_VIEW.filter(item => item.value === payload.typeView)[0] : state.typeView,
                speciality: payload.speciality !== null ? { value: payload.speciality[0] } : state.speciality,
                doctor: payload.doctor !== null ? { value: payload.doctor } : state.doctor,
                showFilter: payload.showFilter !== null ? payload.showFilter : state.showFilter,
            };

            if (payload.doctor !== null) {
                initialState.doctor = payload.doctor;
            }
            if (payload.showFilter !== null) {
                initialState.showFilter = payload.showFilter;
            }

            return {
                ...state,
                typeView: payload.typeView !== null ? TYPES_VIEW.filter(item => item.value === payload.typeView)[0] : state.typeView,
                speciality: payload.speciality !== null ? { value: payload.speciality[0] } : state.speciality,
                doctor: payload.doctor !== null ? { value: payload.doctor } : state.doctor,
                showFilter: payload.showFilter !== null ? payload.showFilter : state.showFilter,
            };
      default:
        return state;
    }
}

export { initialState };
